import React from "react";
import Slider from "react-slick";
import App1 from "../images/new_ap.png";
import App18 from "../images/watchonew.png";
import App2 from "../images/new_Jiohotstar.jpeg";
import App3 from "../images/new_Sonyliv.jpeg";
import App4 from "../images/new_Zee5.jpeg";
import App5 from "../images/new_Chaupal.jpeg";
import App6 from "../images/new_fancode.jpeg";
import App7 from "../images/new_stage.jpeg";
import App8 from "../images/new_games.jpeg";
import App9 from "../images/new_Hungama_Paly.png";
import App10 from "../images/chanajor.png";
import App11 from "../images/new_QZ.jpeg";
import App12 from "../images/new_sanskar.jpeg";
import App13 from "../images/AaoNXT.png";
import App14 from "../images/TARANG.png";
import App25 from "../images/FW ott logo.png";
import App15 from "../images/new_shortstv.jpeg";
import App16 from "../images/new_discovery.jpeg";

export const OttsliderAbove = ({ price }) => {
  const settings2 = {
    dots: false,
    navigation: true,
    loop: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: false,
    speed: 300,
    autoplaySpeed: 3000,
    cssEase: "linear",
  };

  // Hide FW OTT for these plans
  const showFwOtt = !["798", "849", "898", "998", "1248", "1498"].includes(
    String(price),
  );

  return (
    <>
      <div className="ottslider">
        <Slider {...settings2}>
          {showFwOtt && (
            <div>
              <div className="ottimg">
                <img src={App25} alt="FW OTT" />
              </div>
            </div>
          )}

          <div>
            <div className="ottimg">
              <img src={App18} alt="Amazon Prime" />
            </div>
          </div>

          <div>
            <div className="ottimg">
              <img src={App1} alt="Ottplay" />
            </div>
          </div>

          <div>
            <div className="ottimg">
              <img src={App2} alt="Disney Hotstar" />
            </div>
          </div>

          <div>
            <div className="ottimg">
              <img src={App3} alt="Sony LIV" />
            </div>
          </div>

          <div>
            <div className="ottimg">
              <img src={App4} alt="ZEE5" />
            </div>
          </div>

          <div>
            <div className="ottimg">
              <img src={App5} alt="Chaupal" />
            </div>
          </div>

          <div>
            <div className="ottimg">
              <img src={App6} alt="FanCode" />
            </div>
          </div>

          <div>
            <div className="ottimg">
              <img src={App7} alt="STAGE" />
            </div>
          </div>

          <div>
            <div className="ottimg">
              <img src={App10} alt="Chana Jor" />
            </div>
          </div>

          <div>
            <div className="ottimg">
              <img src={App16} alt="Discovery+" />
            </div>
          </div>

          <div>
            <div className="ottimg">
              <img src={App9} alt="Hungama Play" />
            </div>
          </div>

          <div>
            <div className="ottimg">
              <img src={App8} alt="Games" />
            </div>
          </div>

          <div>
            <div className="ottimg">
              <img src={App11} alt="QZ" />
            </div>
          </div>

          <div>
            <div className="ottimg">
              <img src={App12} alt="Sanskar" />
            </div>
          </div>

          <div>
            <div className="ottimg">
              <img src={App13} alt="AaoNXT" />
            </div>
          </div>

          <div>
            <div className="ottimg">
              <img src={App14} alt="Tarang" />
            </div>
          </div>

          <div>
            <div className="ottimg">
              <img src={App15} alt="ShortsTV" />
            </div>
          </div>
        </Slider>
      </div>
    </>
  );
};
